module.exports = __webpack_public_path__ + "img/concrete-inner-corner.955abbc5.png";